import { render, staticRenderFns } from "./pointsNew.vue?vue&type=template&id=255c3f46&"
import script from "./pointsNew.vue?vue&type=script&lang=js&"
export * from "./pointsNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports